import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  createVideoCardAsync,
  updateVideoCardAsync,
  getAllVideoCardsAsync,
  getVideoCardByIdAsync,
  updateStoreProductStatusAsync,
  getCoursePackagesAsync,
  goalWiseCoursePackagesAsync,
  spokenEnglishPackagesAsync,
  deleteVideoCardAsync,
  updateStoreInventoryAsync,
  decreaseStoreInventoryAsync,
  getAllStoreOrdersAsync,
  storeOrderDetailsAsync,
  updateOrderStatusAsync,
} from "./videoCard.async";

const initialState = {
  videoCardLoader: false,
  addVideoCard: [],
  getAllVideoCard: [],
  updateVideoCard: [],
  getVideoCardByIdData: [],
  storePackageStatus: [],
  packageActivation: [],
  allPackages: [],
  packageByGoal: [],
  spokenEnglishPacks: [],
  deleteVideoCard: [],
  updateStoreInventory: [],
  decreaseStoreInventory: [],
  getAllOrders: [],
  getAllOrderById: [],
  updateStatus: [],
};

export const videoCardSlice = createSlice({
  name: "VideoCard",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        getCoursePackagesAsync.pending,
        createVideoCardAsync.pending,
        getAllVideoCardsAsync.pending,
        getVideoCardByIdAsync.pending,
        updateStoreProductStatusAsync.pending,
        updateVideoCardAsync.pending,
        goalWiseCoursePackagesAsync.pending,
        spokenEnglishPackagesAsync.pending,
        deleteVideoCardAsync.pending,
        updateStoreInventoryAsync.pending,
        decreaseStoreInventoryAsync.pending,
        getAllStoreOrdersAsync.pending,
        storeOrderDetailsAsync.pending,
        updateOrderStatusAsync.pending,
      ),
      (state) => {
        state.videoCardLoader = true;
      },
    );

    builder.addMatcher(
      isAnyOf(spokenEnglishPackagesAsync.fulfilled),
      (state, action) => {
        state.videoCardLoader = false;
        state.spokenEnglishPacks = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(goalWiseCoursePackagesAsync.fulfilled),
      (state, action) => {
        state.videoCardLoader = false;
        state.packageByGoal = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(getCoursePackagesAsync.fulfilled),
      (state, action) => {
        state.videoCardLoader = false;
        state.allPackages = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(createVideoCardAsync.fulfilled),
      (state, action) => {
        state.videoCardLoader = false;
        state.addVideoCard = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(getAllVideoCardsAsync.fulfilled),
      (state, action) => {
        state.videoCardLoader = false;
        state.getAllVideoCard = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(getVideoCardByIdAsync.fulfilled),
      (state, action) => {
        state.videoCardLoader = false;
        state.getVideoCardByIdData = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(updateStoreProductStatusAsync.fulfilled),
      (state, action) => {
        state.videoCardLoader = false;
        state.storePackageStatus = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(updateVideoCardAsync.fulfilled),
      (state, action) => {
        state.videoCardLoader = false;
        state.updateVideoCard = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(deleteVideoCardAsync.fulfilled),
      (state, action) => {
        state.videoCardLoader = false;
        state.deleteVideoCard = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(updateStoreInventoryAsync.fulfilled),
      (state, action) => {
        state.videoCardLoader = false;
        state.updateStoreInventory = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(decreaseStoreInventoryAsync.fulfilled),
      (state, action) => {
        state.videoCardLoader = false;
        state.decreaseStoreInventory = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(getAllStoreOrdersAsync.fulfilled),
      (state, action) => {
        state.videoCardLoader = false;
        state.getAllOrders = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(storeOrderDetailsAsync.fulfilled),
      (state, action) => {
        state.videoCardLoader = false;
        state.getAllOrderById = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(updateOrderStatusAsync.fulfilled),
      (state, action) => {
        state.videoCardLoader = false;
        state.updateStatus = action.payload;
      },
    );

    builder.addMatcher(
      isAnyOf(
        getCoursePackagesAsync.rejected,
        updateVideoCardAsync.rejected,
        updateStoreProductStatusAsync.rejected,
        getVideoCardByIdAsync.rejected,
        createVideoCardAsync.rejected,
        getAllVideoCardsAsync.rejected,
        goalWiseCoursePackagesAsync.rejected,
        spokenEnglishPackagesAsync.rejected,
        deleteVideoCardAsync.rejected,
        updateStoreInventoryAsync.rejected,
        decreaseStoreInventoryAsync.rejected,
        getAllStoreOrdersAsync.rejected,
        storeOrderDetailsAsync.rejected,
        updateOrderStatusAsync.rejected,
      ),
      (state, action) => {
        state.videoCardLoader = false;
      },
    );
  },
  reducers: {
    emptyVideoCard: () => initialState,
  },
});

export const { emptyVideoCard } = videoCardSlice.actions;

export default videoCardSlice.reducer;
